import React from "react";
import LegalShell from "../../components/LegalShell";

export default function Guidelines() {
    return (
        <LegalShell title="Community Guidelines" tagline="Keep footsie tasteful. Keep the pod happy." testId="page-guidelines">
            <h2 className="display text-xl font-black">Post</h2>
            <ul className="list-disc pl-5 space-y-1">
                <li><b>Feet only.</b> Photos should be feet-focused. No random selfies, memes, or off-topic content.</li>
                <li><b>Strictly SFW.</b> No nudity, no explicit content, no sexual context. Barefoot, shoes, pedicures, beach shots — all fine.</li>
                <li><b>Your own photos.</b> Do not upload other people&apos;s content without their written consent.</li>
                <li><b>Adults only.</b> Every person visible in the photo must be at least 18 years old.</li>
                <li><b>No commercial spam.</b> Custom profile links are for your socials, personal site, or content — not for scams, phishing, or off-site solicitation.</li>
            </ul>

            <h2 className="display text-xl font-black">Rate</h2>
            <ul className="list-disc pl-5 space-y-1">
                <li>Rate the photo, not the person.</li>
                <li>Be honest. Be kind.</li>
                <li>Do not brigade or coordinate ratings.</li>
            </ul>

            <h2 className="display text-xl font-black">Comment</h2>
            <ul className="list-disc pl-5 space-y-1">
                <li>No harassment, threats, hate speech, or slurs.</li>
                <li>No doxxing — never share real names, addresses, workplaces, or contact info.</li>
                <li>No unsolicited DM-style requests in comments.</li>
            </ul>

            <h2 className="display text-xl font-black">Report</h2>
            <p>See something that breaks the rules? Tap <b>Report</b> on the post or email <a href="mailto:trust@feetrate.app" className="underline">trust@feetrate.app</a>. A single reviewer decision plus three community reports auto-flag a post for immediate review.</p>

            <h2 className="display text-xl font-black">Consequences</h2>
            <p>Violations may result in content removal, feature restrictions (posting, rating, commenting), temporary suspension, or permanent ban — at our discretion. Repeat offenders are removed. Illegal content is reported to authorities as required by law.</p>
        </LegalShell>
    );
}
